
const Ingredient = ({ingredient, portions}) => {
    return (
        <div className = "flex">
            {ingredient.name}
            {ingredient.amount ? ", "+ ingredient.amount*portions : ''}
            {ingredient.unit ? ingredient.unit : ''}
        </div>
    )
}

export default Ingredient
